import { ElementType } from "react";
import SvgIcon from "@mui/material/SvgIcon";
import { ReactComponent as ELIGA_ORDER_LOGO } from "@assets/images/ELIGA_ORDER_LOGO.svg";
import { ReactComponent as ELIGA_ORDER_LOGO_WHITE } from "@assets/images/ELIGA_ORDER_LOGO_WHITE.svg";
import { ReactComponent as SQI_LOGO } from "@assets/images/sqi_icon.svg";
import { ReactComponent as Logout } from "@assets/images/auth/icon_logout.svg";

import { ReactComponent as DARK_EXPAND_MORE } from "@assets/images/common/icon-dark-expand-more.svg";
import { ReactComponent as DARK_EXPAND_LESS } from "@assets/images/common/icon-dark-expand-less.svg";
import { ReactComponent as LIGHT_EXPAND_MORE } from "@assets/images/common/icon-light-expand-more.svg";
import { ReactComponent as LIGHT_EXPAND_LESS } from "@assets/images/common/icon-light-expand-less.svg";
import { ReactComponent as CheckBox } from "@assets/images/common/icon-checkbox.svg";
import { ReactComponent as CheckBoxOn } from "@assets/images/common/icon-checkbox-on.svg";
import { ReactComponent as Sorting } from "@assets/images/common/icon-sorting.svg";
import { ReactComponent as ManageSystem } from "@assets/images/common/icon-manage-system.svg";
import { ReactComponent as ManageSystemOn } from "@assets/images/common/icon-manage-system-on.svg";
import { ReactComponent as Brand } from "@assets/images/common/icon-brand.svg";
import { ReactComponent as BrandOn } from "@assets/images/common/icon-brand-on.svg";
import { ReactComponent as Cafe } from "@assets/images/common/icon-cafe.svg";
import { ReactComponent as CafeOn } from "@assets/images/common/icon-cafe-on.svg";
import { ReactComponent as CafeGray } from "@assets/images/common/icon-cafe-gray.svg";
import { ReactComponent as Dinner } from "@assets/images/common/icon-dinner.svg";
import { ReactComponent as DinnerOn } from "@assets/images/common/icon-dinner-on.svg";
import { ReactComponent as DinnerGray } from "@assets/images/common/icon-dinner-gray.svg";
import { ReactComponent as ArrowDown } from "@assets/images/common/icon-arrow-down.svg";
import { ReactComponent as Search } from "@assets/images/common/icon-search.svg";
import { ReactComponent as ArrowNext } from "@assets/images/common/icon-arrow-next.svg";
import { ReactComponent as Download } from "@assets/images/common/icon-download.svg";
import { ReactComponent as Add } from "@assets/images/common/icon-add.svg";
import { ReactComponent as Trash } from "@assets/images/common/icon-trash.svg";
import { ReactComponent as Pin } from "@assets/images/common/icon-pin.svg";
import { ReactComponent as Shop } from "@assets/images/common/icon-shop.svg";
import { ReactComponent as Email } from "@assets/images/common/icon-email.svg";
import { ReactComponent as People } from "@assets/images/common/icon-people.svg";
import { ReactComponent as Lock } from "@assets/images/common/icon-lock.svg";
import { ReactComponent as EyesOpen } from "@assets/images/common/icon-eyes-open.svg";
import { ReactComponent as EyesClose } from "@assets/images/common/icon-eyes-close.svg";
import { ReactComponent as OkCheck } from "@assets/images/common/icon-check-ok.svg";
import { ReactComponent as XError } from "@assets/images/common/icon-x-error.svg";
import { ReactComponent as Close } from "@assets/images/common/icon-close.svg";
import { ReactComponent as Delete } from "@assets/images/common/icon-delete.svg";
import { ReactComponent as ChevronLeft } from "@assets/images/common/icon-chevron-left.svg";
import { ReactComponent as ChevronRight } from "@assets/images/common/icon-chevron-right.svg";
import { ReactComponent as List } from "@assets/images/common/icon-list.svg";
import { ReactComponent as Grid } from "@assets/images/common/icon-grid.svg";
import { ReactComponent as Image } from "@assets/images/common/icon-image.svg";
import { ReactComponent as Video } from "@assets/images/common/icon-video.svg";
import { ReactComponent as File } from "@assets/images/common/icon-file.svg";
import { ReactComponent as FileBlue } from "@assets/images/common/icon-file-blue.svg";
import { ReactComponent as NoImage } from "@assets/images/common/icon-no-image.svg";
import { ReactComponent as Reload } from "@assets/images/common/icon-reload.svg";
import { ReactComponent as Thumb } from "@assets/images/common/icon-thumb.svg";
import { ReactComponent as ExcelLogo } from "@assets/images/common/icon-excel-logo.svg";
import { ReactComponent as DragDrop } from "@assets/images/common/icon-dragdrop.svg";
import { ReactComponent as Copy } from "@assets/images/common/icon-copy.svg";
import { ReactComponent as Volume } from "@assets/images/device/icon-volume.svg";
import { ReactComponent as Heart } from "@assets/images/common/icon-heart.svg";
import { ReactComponent as Sad } from "@assets/images/common/icon-sad.svg";
import { ReactComponent as Setting } from "@assets/images/common/icon-setting.svg";
import { ReactComponent as CloseGray } from "@assets/images/common/icon-close-gray.svg";
import { ReactComponent as CloseGrayDisabled } from "@assets/images/common/icon-close-gray-disabled.svg";
import { ReactComponent as New } from "@assets/images/common/icon-new.svg";
import { ReactComponent as Card } from "@assets/images/common/icon-card.svg";
import { ReactComponent as Employee } from "@assets/images/common/icon-employee.svg";
import { ReactComponent as Home } from "@assets/images/common/icon-home.svg";
import { ReactComponent as Upload } from "@assets/images/storage/icon-upload.svg";
import { ReactComponent as MemberPlus } from "@assets/images/common/icon-member-plus.svg";
import { ReactComponent as EmailCheck } from "@assets/images/common/icon-email-check.svg";
import { ReactComponent as Qr } from "@assets/images/common/icon-qr.svg";
import { ReactComponent as DefaultEmployee } from "@assets/images/default_employee_icon.svg";
import { ReactComponent as NoCourse } from "@assets/images/common/icon-no-course.svg";
import { ReactComponent as HamburgMenu } from "@assets/images/common/icon-hamburg.svg";

function Icon(props: any, component: ElementType) {
  return <SvgIcon sx={{ fill: "none !important" }} component={component} inheritViewBox={true} {...props} />;
}

export const EligaOrderLogoIcon = (props: any) => Icon(props, ELIGA_ORDER_LOGO);
export const EligaOrderLogoWhiteIcon = (props: any) => Icon(props, ELIGA_ORDER_LOGO_WHITE);
export const SqiLogoIcon = (props: any) => Icon(props, SQI_LOGO);
export const LogoutIcon = (props: any) => Icon(props, Logout);

export const DarkExpandLessIcon = (props: any) => Icon(props, DARK_EXPAND_LESS);
export const DarkExpandMoreIcon = (props: any) => Icon(props, DARK_EXPAND_MORE);
export const LightExpandLessIcon = (props: any) => Icon(props, LIGHT_EXPAND_LESS);
export const LightExpandMoreIcon = (props: any) => Icon(props, LIGHT_EXPAND_MORE);

export const CheckBoxIcon = (props: any) => Icon(props, CheckBox);
export const CheckBoxOnIcon = (props: any) => Icon(props, CheckBoxOn);
export const SortingIcon = (props: any) => Icon(props, Sorting);

export const ManageSystemIcon = (props: any) => Icon(props, ManageSystem);
export const ManageSystemOnIcon = (props: any) => Icon(props, ManageSystemOn);
export const BrandIcon = (props: any) => Icon(props, Brand);
export const BrandOnIcon = (props: any) => Icon(props, BrandOn);
export const CafeIcon = (props: any) => Icon(props, Cafe);
export const CafeOnIcon = (props: any) => Icon(props, CafeOn);
export const CafeGrayIcon = (props: any) => Icon(props, CafeGray);
export const DinnerIcon = (props: any) => Icon(props, Dinner);
export const DinnerOnIcon = (props: any) => Icon(props, DinnerOn);
export const DinnerGrayIcon = (props: any) => Icon(props, DinnerGray);

export const ArrowDownIcon = (props: any) => Icon(props, ArrowDown);
export const SearchIcon = (props: any) => Icon(props, Search);

export const ArrowNextIcon = (props: any) => Icon(props, ArrowNext);
export const DownloadIcon = (props: any) => Icon(props, Download);
export const AddIcon = (props: any) => Icon(props, Add);
export const NewIcon = (props: any) => Icon(props, New);
export const TrashIcon = (props: any) => Icon(props, Trash);

export const PinIcon = (props: any) => Icon(props, Pin);
export const ShopIcon = (props: any) => Icon(props, Shop);
export const EmailIcon = (props: any) => Icon(props, Email);
export const PeopleIcon = (props: any) => Icon(props, People);
export const LockIcon = (props: any) => Icon(props, Lock);
export const EyesOpenIcon = (props: any) => Icon(props, EyesOpen);
export const EyesCloseIcon = (props: any) => Icon(props, EyesClose);

export const OkCheckIcon = (props: any) => Icon(props, OkCheck);
export const MemberPlusIcon = (props: any) => Icon(props, MemberPlus);
export const EmailCheckIcon = (props: any) => Icon(props, EmailCheck);
export const XErrorIcon = (props: any) => Icon(props, XError);

export const CloseIcon = (props: any) => Icon(props, Close);
export const ChevronLeftIcon = (props: any) => Icon(props, ChevronLeft);
export const ChevronRightIcon = (props: any) => Icon(props, ChevronRight);

export const ListIcon = (props: any) => Icon(props, List);
export const ThumbIcon = (props: any) => Icon(props, Thumb);
export const GridIcon = (props: any) => Icon(props, Grid);
export const ImageIcon = (props: any) => Icon(props, Image);
export const VideoIcon = (props: any) => Icon(props, Video);
export const FileIcon = (props: any) => Icon(props, File);
export const FileBlueIcon = (props: any) => Icon(props, FileBlue);
export const NoImageIcon = (props: any) => Icon(props, NoImage);
export const NoCourseIcon = (props: any) => Icon(props, NoCourse);

export const VolumeIcon = (props: any) => Icon(props, Volume);
export const ReloadIcon = (props: any) => Icon(props, Reload);

export const ExcelLogoIcon = (props: any) => Icon(props, ExcelLogo);
export const DragDropIcon = (props: any) => Icon(props, DragDrop);
export const DeleteIcon = (props: any) => Icon(props, Delete);
export const CopyIcon = (props: any) => Icon(props, Copy);

export const HeartIcon = (props: any) => Icon(props, Heart);
export const SadIcon = (props: any) => Icon(props, Sad);
export const SettingIcon = (props: any) => Icon(props, Setting);
export const CloseGrayIcon = (props: any) => Icon(props, CloseGray);
export const CloseGrayDisabledIcon = (props: any) => Icon(props, CloseGrayDisabled);

export const CardIcon = (props: any) => Icon(props, Card);
export const EmployeeIcon = (props: any) => Icon(props, Employee);
export const HomeIcon = (props: any) => Icon(props, Home);

export const UploadIcon = (props: any) => Icon(props, Upload);
export const QrIcon = (props: any) => Icon(props, Qr);

export const DefaultEmployeeIcon = (props: any) => Icon(props, DefaultEmployee);

export const HamburgMenuIcon = (props: any) => Icon(props, HamburgMenu);